import Vue from "vue";
import Router from "vue-router";
import global from "@/core/global/global";
import manageServe from "@/core/api/manage.serve";
import store from '@/core/store/index'
var param = global.global.getParam();
Vue.use(Router);
import operation_routers from "./operation_routers"; // //运营管理员路由
import manage_routers from "./manage_routers"; //登录注册
import caibian_routers from "./caibian_routers"; // 采编的路由
import expert_routers from "./expert_routers"; // 专家
import finance_routers from "./finance_routers"; // 财务
import organizational_management from "./organizationalManagement_routers"; // 集团管理
import editorialReview_routers from "./editorialReview_routers"; //编辑部审核
var projects = [
  operation_routers, //运营管理员
  manage_routers,
  caibian_routers,
  expert_routers,
  finance_routers,
  organizational_management, // 审核流程
  editorialReview_routers,
];

var routes = (branches) => {
  var merge = [];
  branches.map(function(item) {
    merge.push.apply(merge, item);
  });
  return merge;
};
var router = new Router({
  routes: routes(projects),
});

router.beforeEach((to, from, next) => {
  var session = sessionStorage.getItem("userInfo");

  if (to.path == "/loginAdmin") {
    next();
  } else if (to.path == "/") {
    next({ path: "/loginAdmin" });
  } else {
    if (session || to.path == "/myCard") {
      next();
    } else {
      next({ path: "/loginAdmin" });
    }
  }
  
  if (sessionStorage.getItem("userInfo") && JSON.parse(sessionStorage.getItem("userInfo")).token && JSON.parse(sessionStorage.getItem("userInfo")).info.perId) {
    let perId = JSON.parse(sessionStorage.getItem("userInfo")).info.perId
    manageServe.haveMsg({perId:perId ? perId : ""}).then((res) => {
      if(res.resultCode == "200"){
        if(res.data > 0){
          sessionStorage.setItem("message",true)
        }else{
          sessionStorage.setItem("message",false)
        }
        store.commit('GET_MESSAGE')
      }
    })
  }
  
});

const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => error);
};
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js